G.AnimationElement = function(x,y,data,autoplay){

	G.Image.call(this,x,y,null);

	this.ANIMATIONELEMENT = true;

	//we need to have this element, so constructor act as wrapper
	//so it can be placed, rotated and scaled without affecting
	//values on timelines
	this.SPR = new G.Image(0,0,null,0.5,this); 

	this.frameCounter = 0;
	this.data = data;

	this.currentAnimationData = null;
	this.currentAnimationName = null;

	this.playing = autoplay === undefined ? true : autoplay;

};

G.AnimationElement.prototype = Object.create(G.Image.prototype);

G.AnimationElement.prototype.update = function(){

	if (!this.currentAnimationName) return;

	if (this.playing){
		this.frameCounter++;
		this.updateAnimation(this.frameCounter);
	}
	
};

G.AnimationElement.prototype.pause = function(){
	this.playing = false;
};

G.AnimationElement.prototype.resume = function(){
	this.playing = true;
};

G.AnimationElement.prototype.play = function(){
	this.playing = true;
};

G.AnimationElement.prototype.stop = function(){
	this.playing = false;
	this.updateAnimation(0);
};

/*G.AnimationElement.prototype.getTotalLength = function(){

	var len = Infinity;

	for (var i = 0; i < this.propKeys.length; i++){
		len = Math.min(
			this.propTLS[this.propKeys[0]].length,
			len
		);
	}

	len = Math.min(this.eventTL.length,len);

	return len;

};*/

/*
G.AnimationElement.prototype.init = function(dataInit){

	this.SPR.x = dataInit.x;
	this.SPR.y = dataInit.y;
	this.SPR.angle = dataInit.angle;
	this.SPR.scale.setTo(dataInit.scale[0],dataInit.scale[1]);
	this.SPR.changeTexture(dataInit.frame);
	this.SPR.anchor.setTo(dataInit.anchor[0],dataInit.anchor[1]);

};*/

var testObj = {
	normal: {
		eventTL: [],
		frameTL: [{f:0, v:'candy_1'}],
		propTLS: {
			alpha: [{f:0,v:1}],
			x: [{f:0,v:0}],
			y: [{f:0,v:0}],
			angle: [{f:0,v:0}],
			'scale.x': [{f:0,v:1}],
			'scale.y': [{f:0,v:1}],
			'anchor.x':  [{f:0,v:0.5}],
			'anchor.y':  [{f:0,v:1}]
		}
	},
	jump: {
		eventTL: [],
		frameTL: [{f:0, v:null}],
		propTLS: {
			alpha: [{f:0,v:1}],
			x: [{f:0,v:0}],
			y: [{f:0,v:0},{f:120,v:-300}],
			angle: [{f:0,v:0,e:['Linear','None']},{f:400,v:360}],
			'scale.x': [{f:0,v:1}],
			'scale.y': [{f:0,v:1}],
			'anchor.x':  [{f:0,v:0.5}],
			'anchor.y':  [{f:0,v:1}]
		}
	}
}

G.AnimationElement.prototype.changeAnimationData = function(animationName){

	if (!this.data[animationName]){
		animationName = Object.keys(this.data)[0];
	}

	this.eventTL = this.data[animationName].eventTL;
	this.frameTL = this.data[animationName].frameTL;
	this.propTLS = this.data[animationName].propTLS;
	this.propKeys = Object.keys(this.propTLS);
	this.currentAnimationData = this.data[animationName];
	this.currentAnimationName = animationName;
	this.updateAnimation(0);
	

};

G.AnimationElement.prototype.playAnimation = function(animationName){

	this.changeAnimationData(animationName);
	this.playing = true;

};

G.AnimationElement.prototype.getLastKeyFrame = function(tl,frameNr){

	var len = tl.length;
	for (var i = 0; i < len; i++){
		if (tl[i].f == frameNr || i == len-1) return tl[i];
		if (tl[i].f < frameNr && frameNr < tl[i+1].f){
			return tl[i];
		}
	};

};

G.AnimationElement.prototype.getNextKeyFrame = function(tl,frameNr){

	var len = tl.length;
	for (var i = 0; i < len; i++){
		if (tl[i].f > tl || i == len-1){
			return tl[i];
		}
	};

};

G.AnimationElement.prototype.getKeyFrameAt = function(tl,frameNr){

	if (!this.currentAnimationName) return null;

	for (var i = 0; i < tl.length; i++){
		var keyFrame = tl[i];
		if (keyFrame.f === frameNr) return keyFrame;
	}

	return null;
}

G.AnimationElement.prototype.isAnyKeyFrameAt = function(frameNr){

	if (!this.currentAnimationName) return false;

	if (this.getKeyFrameAt(this.eventTL,frameNr)) return true;
	if (this.getKeyFrameAt(this.frameTL,frameNr)) return true;

	for (var i = 0; i < this.propKeys.length; i++){
		var key = this.propKeys[i];
		if (this.getKeyFrameAt(this.propTLS[key],frameNr)) {
			return true;
		}
	}

	return false;

};

G.AnimationElement.prototype.getFrameValue = function(tl,frameNr){

	var lastKey = this.getLastKeyFrame(tl,frameNr);
	var nextKey = this.getNextKeyFrame(tl,frameNr);

	if (!lastKey.e){
		return lastKey.v;
	}else{
		var animLength = nextKey.f - lastKey.f;
		var valDiff = nextKey.v-lastKey.v;
		var easingVal = Phaser.Easing[lastKey.e[0]][lastKey.e[1]]((frameNr-lastKey.f)/animLength);
		return lastKey.v + (valDiff*easingVal);
	}

};


G.AnimationElement.prototype.updateAnimation = function(frameNr){

	if (!this.currentAnimationName) return;

	this.frameCounter = frameNr;

	this.updateFromPropTLS(frameNr);

	var frame = this.getTextureFrameValue(this.frameTL,frameNr);
	if (this.SPR.key != frame && this.SPR.frameName != frame){
		G.changeTexture(this.SPR,frame);
	}


}

G.AnimationElement.prototype.updateFromPropTLS = function(frameNr){

	for (var i = 0; i < this.propKeys.length; i++){
		var key = this.propKeys[i];
		this.setProp(key,this.getFrameValue(this.propTLS[key],frameNr));
	}

};

// lets make it a bit faster
G.AnimationElement.prototype.setProp = function(key,value){

	if (key == 'scale.x') this.SPR.scale.x = value;
	else if (key == 'scale.y') this.SPR.scale.y = value;
	else if (key == 'anchor.x') this.SPR.anchor.x = value;
	else if (key == 'anchor.y') this.SPR.anchor.y = value;
	else this.SPR[key] = value;

};


G.AnimationElement.prototype.getTextureFrameValue = function(tl,frameNr){

	var lastKey = this.getLastKeyFrame(tl,frameNr);

	var frameSkip = lastKey.frameSkip || 1;

	var frameDiff = frameNr-lastKey.f;

	frameDiff = Math.floor(frameDiff/frameSkip);

	if (!lastKey.animation){
		return lastKey.v;
	}else{

		var len = lastKey.v.length;

		if (lastKey.loop){
			
			if (!lastKey.refraction && !lastKey.reverse){
				return lastKey.v[frameDiff % len];
			}
			/*else if (!lastKey.refraction && lastKey.reverse){
				var fmod = frameNr % (len*2);
				return fmod < len ? lastKey.v[fmod] : (len-1)-(fmod-len);
			}*/
			else if (lastKey.refraction && !lastKey.reverse){
				return lastKey.v[Math.min(len-1,(frameDiff % (len+lastKey.refraction)))];
			}/*else if (lastKey.refraction && lastKey.reverse){

			}*/

		}else{
			return lastKey.v[Math.min(len-1,frameDiff)];			
		}
	}

}